<mat-toolbar>
    <div class="toolbar-left">
        <div class="toolbar-item">
            Experiment 1
        </div>
    </div>
    <div class="toolbar-right">
        <div class="toolbar-item button">
            <p>Download Results</p>
        </div>
    </div>
</mat-toolbar>
<div class="content-body-background"></div>
<div class="content-body">
    <app-experiment-content></app-experiment-content>
</div>